var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { DrawerEmptyState, LoadingBox, Trans, translate, UserXIcon, } from '@lucidlink/uicore';
import { useDecryptWithWorkspaceCommonKey } from '../../query-hooks/queries/useDecryptWithWorkspaceCommonKey';
import { GuestDetailsDrawerContent } from './GuestDetailsDrawerContent';
import { GuestDetailsDrawerTestIdFactory } from './interactions';
export const GuestDetailsDrawer = ({ closeDrawer, params, }) => {
    _react_refresh_temp_2();
    const { eGuestEmail, filespaceId, workspaceId } = params;
    const { data: guestEmail, isError, isPending, } = useDecryptWithWorkspaceCommonKey({
        encryptedValue: eGuestEmail,
        workspaceId,
    });
    if (isPending) {
        return (_jsx(LoadingBox, { alt: translate('loading data'), "data-testid": GuestDetailsDrawerTestIdFactory.getLoadingTestId(), isFullHeight: true, isFullWidth: true, justify: "center" }));
    }
    if (isError) {
        return (_jsx(DrawerEmptyState, { color: "red", "data-testid": GuestDetailsDrawerTestIdFactory.getLoadErrorTestId(), Icon: UserXIcon, message: _jsx(Trans, { children: "An error occurred. The guest couldn\u2019t be loaded." }) }));
    }
    return (_jsx(GuestDetailsDrawerContent, { closeDrawer: closeDrawer, filespaceId: filespaceId, guestEmail: guestEmail, workspaceId: workspaceId }));
};
_react_refresh_temp_1 = GuestDetailsDrawer;
$RefreshReg$(_react_refresh_temp_1, "GuestDetailsDrawer");
_react_refresh_temp_2(GuestDetailsDrawer, "zfLjysR/A8+URjhk+GWNzsIV2w0=", false, () => [useDecryptWithWorkspaceCommonKey]);
